'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _common = require('../../common');

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _StatuteOfLimitationsInsight = require('./StatuteOfLimitationsInsight');

var _StatuteOfLimitationsInsight2 = _interopRequireDefault(_StatuteOfLimitationsInsight);

var _MVAUnderwritingInsight = require('./MVAUnderwritingInsight');

var _MVAUnderwritingInsight2 = _interopRequireDefault(_MVAUnderwritingInsight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var BRAND_NAME = _AppConstants2.default.BRAND_NAME;
var UnderwritingInsights = (_dec = (0, _mobxReact.inject)('CaseStore', 'OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(UnderwritingInsights, _Component);

  function UnderwritingInsights() {
    _classCallCheck(this, UnderwritingInsights);

    return _possibleConstructorReturn(this, (UnderwritingInsights.__proto__ || Object.getPrototypeOf(UnderwritingInsights)).apply(this, arguments));
  }

  _createClass(UnderwritingInsights, [{
    key: 'renderDisclaimer',
    value: function renderDisclaimer() {
      return _react2.default.createElement(
        _common.InfoWell,
        null,
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _common.InfoWell.Label,
            null,
            'DISCLAIMER'
          ),
          _react2.default.createElement(
            _common.InfoWell.Value,
            null,
            _react2.default.createElement(
              'p',
              null,
              BRAND_NAME,
              ' does its best to provide accurate information, but is not responsible for unintentional errors or omissions. You should double check all information before relying on it.'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _case = _props._case,
          CaseStore = _props.CaseStore,
          OptionsStore = _props.OptionsStore,
          caseType = OptionsStore.getCaseTypeOptionById(_case.type).name,
          stateMVAThreshold = CaseStore.stateMVAThreshold,
          statuteOfLimitations = CaseStore.statuteOfLimitations,
          isMVA = caseType === 'Motor Vehicle Accident',
          hasMVA = isMVA && (0, _mobx.toJS)(stateMVAThreshold.state),
          hasStatute = !!caseType && (0, _mobx.toJS)(statuteOfLimitations.state);


      if (!(hasMVA || hasStatute)) {
        return null;
      }

      return _react2.default.createElement(
        _Well2.default,
        { className: 'insight-wrapper' },
        _react2.default.createElement(
          _common.InfoWell,
          null,
          hasStatute && _react2.default.createElement(_StatuteOfLimitationsInsight2.default, {
            statuteOfLimitations: statuteOfLimitations,
            caseType: caseType
          }),
          hasMVA && _react2.default.createElement(_MVAUnderwritingInsight2.default, {
            stateMVAThreshold: stateMVAThreshold
          }),
          this.renderDisclaimer()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return UnderwritingInsights;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = UnderwritingInsights;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BRAND_NAME, 'BRAND_NAME', '/app/src/components/page-case/main-underwriting/UnderwritingInsights.js');
  reactHotLoader.register(UnderwritingInsights, 'UnderwritingInsights', '/app/src/components/page-case/main-underwriting/UnderwritingInsights.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-underwriting/UnderwritingInsights.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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